import { FormItemController } from "./FormItemController";
import { Selector } from "../../HTML/Editor/Selector";
import { Select } from "../../HTML/Form/Item/Select";
import { toMap, timeout } from "../../../../HA";

export class SelectController extends FormItemController {

    public getValue() {
        return this.getTag().getSelected();
    }

    public isInputItem() {
        return true;
    }

    protected createItem() {
        const data = toMap({tag: this.getTag()});
        this.attachModalEntry(
            data,
            (cfg) => new Selector(cfg),
            {
                // L'acceptation par bouton ferme (base) puis applique les sélections.
                onAccept: (selections) => this.applySelections(selections),
                // Auto-accept au clic d'item quand le max est atteint (spécifique
                // Select : pfunc reçoit l'instance de l'éditeur en différé).
                configure: (cfg, getEditor) => {
                    cfg.set("pfunc", {
                        itemClick: (d: any) => this.itemClicked(d, getEditor()),
                    });
                },
            },
        );
        return new Select(data);
    }

    protected replaceItems(items: any[]) {
        this.getTag().replaceItems(items);
    }

    protected getChoices() {
        return this.getTag().getChoices();
    }

    protected initItem() {
        super.initItem();
        this.addToData("max", this.getTag().getMax());
    }

    private itemClicked(data: any, tag: Selector): void {
        const max = this.get("max");
        if (!max || max > tag.getSelections().length) {
            return;
        }
        if (max === 1) {
            tag.deselectAll();
            tag.select(data);
        }
        // Chemin auto-accept (hors bouton) : il ferme lui-même puis applique.
        this.getFormController().closeSelection(this.getAppId());
        this.applySelections(tag.getSelections());
    }

    private applySelections(selections: any): void {
        this.replaceItems(selections);
        timeout(() => { this.getTag().scrollIntoView(); }, 200);
    }
}
